import type { LucideIcon } from 'lucide-react';
import type { ComponentPropsWithoutRef, Ref } from 'react';
import { cx } from '../../utils/cx';
import { Icon } from '../Icon/Icon';
import s from './IconButton.module.css';

export type IconButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'children'> & {
  ref?: Ref<HTMLButtonElement>;
  icon: LucideIcon;
  /** Required accessible name, e.g. "Notifications". */
  label: string;
  variant?: 'ghost' | 'secondary' | 'primary' | 'fun';
  /** Visual size. The hit area is always at least 44px. */
  size?: 'sm' | 'md' | 'lg';
};

export function IconButton({
  icon,
  label,
  variant = 'ghost',
  size = 'md',
  className,
  type,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type ?? 'button'}
      className={cx(s.iconButton, className)}
      data-variant={variant}
      data-size={size}
      aria-label={label}
      title={label}
      {...rest}
    >
      <Icon icon={icon} size={size === 'sm' ? 'md' : 'lg'} />
    </button>
  );
}
